import React from 'react';

function Services() {
  return (
    <div>
      <section
        id="services"
        class="services section-bg"
        style={{ scrollMarginTop: '20px' }}
      >
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <br />
            <h2>Services</h2>
            <p>
              <strong>Secure, Reliable & Affordable Solutions</strong>
            </p>
          </div>

          <div class="row">
            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div class="icon-box">
                <div class="icon">
                  <i class="bx bxl-dribbble"></i>
                </div>
                <h4>
                  <a href> Website Hosting </a>
                </h4>
                <p>
                  Get fast, secure, and reliable web hosting with 99.9% uptime,
                  Enterprise LiteSpeed, and NVMe SSD storage for top-tier
                  performance. Easily manage your site with cPanel, Softaculous,
                  and automated JetBackup, while enjoying Anti-DDoS protection
                  and Free SSL certificates for enhanced security.
                </p>
              </div>
            </div>

            {/* <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div class="icon-box">
                <div class="icon">
                  <i class="bx bx-file"></i>
                </div>
                <h4>
                  <a href>Domain Registration</a>
                </h4>
                <p>
                  Secure your online presence with hassle-free domain
                  registration at competitive prices. Choose from a wide range
                  of domain extensions and enjoy seamless integration with your
                  hosting plan. Our easy-to-use platform ensures quick setup and
                  full DNS management.
                </p>
              </div>
            </div>
             */}

            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div class="icon-box">
                <div class="icon">
                  <i class="bx bx-file"></i>
                </div>
                <h4>
                  <a href>DIY Website Builder (Coming Soon)</a>
                </h4>
                <p>
                  We’re working on an easy-to-use DIY website builder that will
                  let you create stunning, professional websites without any
                  coding skills. Whether you're building a blog, portfolio, or
                  business site, our intuitive builder will help you go live in
                  minutes — all while keeping things affordable.
                </p>
              </div>
            </div>

            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div class="icon-box">
                <div class="icon">
                  <i class="bx bx-tachometer"></i>
                </div>
                <h4>
                  <a href>Windows Product License</a>
                </h4>
                <p>
                  Get 100% genuine Windows product licenses at unbeatable
                  prices. Whether you need Windows 10, Windows 11, or server
                  editions, we provide authentic, lifetime activation keys. We
                  also offer genuine Microsoft Office licenses, ensuring full
                  access to essential productivity tools with regular updates
                  and security patches.
                </p>
              </div>
            </div>

            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div class="icon-box">
                <div class="icon">
                  <i class="bx bx-layer"></i>
                </div>
                <h4>
                  <a href>Antivirus and Other Software</a>
                </h4>
                <p>
                  Protect your devices with original antivirus software and
                  other essential digital tools. We offer licensed security
                  solutions from top brands, helping safeguard your system
                  against malware, cyber threats, and data breaches.
                </p>
              </div>
            </div>
            {/* <div
                class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                <div class="icon-box">
                  <div class="icon">
                    <i class="bx bx-layer"></i>
                  </div>
                  <h4>
                    <a href>Loan Proposal</a>
                  </h4>
                  <p>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis
                  </p>
                </div>
              </div> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
